import React from 'react';
import PropTypes from 'prop-types';

export const RadioButton = ({isSelected, onChange}) => {
  return (
    <input
      type='radio'
      value=''
      checked={isSelected}
      onChange={onChange}
      data-testid='radio-move-stores'
    />
  );
};

RadioButton.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};
